import { render, staticRenderFns } from "./PageEight.vue?vue&type=template&id=163baca3&scoped=true&"
import script from "./PageEight.vue?vue&type=script&lang=js&"
export * from "./PageEight.vue?vue&type=script&lang=js&"
import style0 from "./PageEight.vue?vue&type=style&index=0&id=163baca3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163baca3",
  null
  
)

export default component.exports